import Dayjs from 'dayjs';

export function timeConverter(date: any) {
  const currentDate = new Date(parseInt(date));
  const result = Dayjs(currentDate).format('MM/DD/YYYY');
  return result;
}

